import { stringify } from '@angular/compiler/src/util';
import { group } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
import { LoginService } from 'src/app/shared/API-Service/services/login.service';
@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styles: [
  ]
})
export class ChangePasswordComponent implements OnInit {

  changepasswordForm:FormGroup;
  button:boolean = false;
  DisableBtn: boolean;
  constructor(private _FormBuilder: FormBuilder, private _router:Router,private _LoginService:LoginService) {}
  ngOnInit(): void {
    this.initiate();
   }

  initiate(){
    this.changepasswordForm = this._FormBuilder.group({
      currentPassword: ['', Validators.required],
      newPassword: ['', Validators.required]
    });
  }
  get fc() {
    return this.changepasswordForm.controls;
  }

    
  onSubmit() {
    if (this.changepasswordForm.status == "VALID") {
      this.DisableBtn=true
      this._LoginService.changepassword(this.changepasswordForm.value).subscribe((res) => {
        this.changepasswordForm.reset();
        Swal.fire({
          icon: "success",
          title: "password changed Successfuly",
          showConfirmButton: false,
          timer: 1500,
        });
        this.DisableBtn=false

      },(err) => {
        this.DisableBtn=false
      },() => {
      })
    }
     else {
      this.DisableBtn=false
      this.changepasswordForm.markAllAsTouched();
    }
   
  }


}
